



















import { Component, Emit, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import 'vue-simple-suggest/lib/polyfills';
import VueSimpleSuggest from 'vue-simple-suggest/lib';
import 'vue-simple-suggest/dist/styles.css';
import Api from '@/Api';
import { State } from 'vuex-class';

@Component({
  components: {
    VueSimpleSuggest,
  },
})
export default class Location extends Vue {
  @Ref() private readonly simpleSuggest!: any;
  @Prop() private location!: string | null;

  private query = '';
  private selection = '';

  public updateLocation() {
    let loc = this.location;
    if (loc == null) {
      loc = '';
    }
    this.setTexts(loc);
  }

  private mounted() {
    this.updateLocation();
  }

  private autoSelect(e: any) {
    if (this.query.length === 0) {
      this.selection = '';
      this.locationChosen();
      return;
    }
    if (this.query.length !== 0 && this.simpleSuggest.selected === null && this.simpleSuggest.suggestions.length > 0) {
      this.setTexts(this.simpleSuggest.suggestions[0]);
      this.simpleSuggest.setText(this.simpleSuggest.suggestions[0]);
      this.locationChosen();
    }
  }

  private setTexts(input: string) {
    this.selection = input;
    this.query = input;
  }

  @Emit()
  private locationChosen() {
    return this.selection;
  }
  private locationSelected() {
    if (this.selection === null) {
      return;
    }
    this.locationChosen();
  }

  private async getList() {
    if (this.query.length >= 2) {
      return await Api.GeoComplete(this.query);
    }
    return [];
  }
}
